var _defs, _path, _path2, _path3, _linearGradient, _path4, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -189 539.9995 160",
    width: 539.9995,
    height: 160,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.00216007232666, 0, 0, 4.001100063323975, 0, -189)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M134.032 35.268a3.83 3.83 0 0 1-3.834 3.83H4.729a3.835 3.835 0 0 1-3.839-3.83V4.725A3.84 3.84 0 0 1 4.729.89h125.468a3.834 3.834 0 0 1 3.834 3.835l.001 30.543z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A6A6",
    d: "M130.198 39.989H4.729A4.73 4.73 0 0 1 0 35.268V4.726A4.733 4.733 0 0 1 4.729 0h125.468a4.735 4.735 0 0 1 4.729 4.726v30.542c.002 2.604-2.123 4.721-4.728 4.721z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.032 35.268a3.83 3.83 0 0 1-3.834 3.83H4.729a3.835 3.835 0 0 1-3.839-3.83V4.725A3.84 3.84 0 0 1 4.729.89h125.468a3.834 3.834 0 0 1 3.834 3.835l.001 30.543z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -23.235,
    y1: 97.431,
    x2: -23.235,
    y2: 61.386,
    gradientTransform: "matrix(4.0022 0 0 4.0011 191.95 -349.736)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1a",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.123,
    stopColor: "#212121",
    stopOpacity: 0.151
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    stopColor: "#353535",
    stopOpacity: 0.227
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.532,
    stopColor: "#575757",
    stopOpacity: 0.318
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#858585",
    stopOpacity: 0.421
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3",
    stopOpacity: 0.51
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M130.198 0H62.993l26.323 39.989h40.882a4.733 4.733 0 0 0 4.729-4.724V4.726A4.734 4.734 0 0 0 130.198 0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.090275, 0, 0, 1.005579, -0.394453, -0.528521)",
    style: {}
  }, _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.8,
    y1: 33.29,
    x2: 5.017,
    y2: 16.508,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.4 7.5c-.3.3-.4.8-.4 1.4V31c0 .6.2 1.1.5 1.4l.1.1L23 20.1v-.2L10.4 7.5z",
    style: {
      fill: "url('#SVGID_1_')"
    }
  }), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.834,
    y1: 21.999,
    x2: 9.637,
    y2: 21.999,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27 24.3l-4.1-4.1V19.9l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9l-5 2.7z",
    style: {
      fill: "url('#SVGID_2_')"
    }
  }), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.827,
    y1: 19.704,
    x2: 2.069,
    y2: -3.054,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.1 24.2L22.9 20 10.4 32.5c.5.5 1.2.5 2.1.1l14.6-8.4",
    style: {
      fill: "url('#SVGID_3_')"
    }
  }), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.297,
    y1: 41.824,
    x2: 17.46,
    y2: 31.661,
    gradientTransform: "matrix(1 0 0 -1 0 42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.1 15.8L12.5 7.5c-.9-.5-1.6-.4-2.1.1L22.9 20l4.2-4.2z",
    style: {
      fill: "url('#SVGID_4_')"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27 24.1l-14.5 8.2c-.8.5-1.5.4-2 0l-.1.1.1.1c.5.4 1.2.5 2 0L27 24.1z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.4 32.3c-.3-.3-.4-.8-.4-1.4v.1c0 .6.2 1.1.5 1.4v-.1h-.1zM32 21.3l-5 2.8.1.1 4.9-2.8c.7-.4 1-.9 1-1.4 0 .5-.4.9-1 1.3z",
    style: {
      opacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.5 7.6L32 18.7c.6.4 1 .8 1 1.3 0-.5-.3-1-1-1.4L12.5 7.5c-1.4-.8-2.5-.2-2.5 1.4V9c0-1.5 1.1-2.2 2.5-1.4z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 68.281 23.014 C 65.945 23.014 64.099 24.743 64.099 27.15 C 64.099 29.461 65.945 31.291 68.281 31.291 C 70.618 31.291 72.468 29.557 72.468 27.15 C 72.468 24.647 70.618 23.014 68.281 23.014 Z M 68.281 29.557 C 67.016 29.557 65.945 28.498 65.945 27.054 C 65.945 25.609 67.016 24.55 68.281 24.55 C 69.547 24.55 70.618 25.513 70.618 27.054 C 70.618 28.498 69.547 29.557 68.281 29.557 Z M 59.231 23.014 C 56.898 23.014 55.048 24.743 55.048 27.15 C 55.048 29.461 56.898 31.291 59.231 31.291 C 61.567 31.291 63.417 29.557 63.417 27.15 C 63.417 24.647 61.567 23.014 59.231 23.014 Z M 59.231 29.557 C 57.969 29.557 56.898 28.498 56.898 27.054 C 56.898 25.609 57.969 24.55 59.231 24.55 C 60.497 24.55 61.567 25.513 61.567 27.054 C 61.567 28.498 60.497 29.557 59.231 29.557 Z M 48.432 24.261 L 48.432 25.995 L 52.614 25.995 C 52.517 26.958 52.128 27.728 51.641 28.209 C 51.06 28.787 50.087 29.461 48.432 29.461 C 45.803 29.461 43.86 27.439 43.86 24.839 C 43.86 22.243 45.9 20.221 48.432 20.221 C 49.795 20.221 50.866 20.799 51.641 21.473 L 52.906 20.221 C 51.835 19.258 50.476 18.488 48.529 18.488 C 45.024 18.488 42.01 21.377 42.01 24.839 C 42.01 28.306 45.024 31.194 48.529 31.194 C 50.476 31.194 51.835 30.616 53.004 29.365 C 54.172 28.209 54.562 26.572 54.562 25.321 C 54.562 24.935 54.562 24.55 54.464 24.261 L 48.432 24.261 Z M 92.609 25.609 C 92.22 24.647 91.246 23.014 89.104 23.014 C 86.966 23.014 85.214 24.647 85.214 27.15 C 85.214 29.461 86.966 31.291 89.299 31.291 C 91.149 31.291 92.317 30.135 92.707 29.461 L 91.344 28.498 C 90.857 29.172 90.273 29.654 89.299 29.654 C 88.326 29.654 87.741 29.268 87.259 28.402 L 92.804 26.091 L 92.609 25.609 Z M 86.966 26.958 C 86.966 25.417 88.228 24.55 89.104 24.55 C 89.786 24.55 90.467 24.935 90.662 25.417 L 86.966 26.958 Z M 82.391 30.905 L 84.24 30.905 L 84.24 18.873 L 82.391 18.873 L 82.391 30.905 Z M 79.474 23.88 C 78.987 23.399 78.208 22.917 77.234 22.917 C 75.19 22.917 73.243 24.743 73.243 27.054 C 73.243 29.365 75.093 31.098 77.234 31.098 C 78.208 31.098 78.987 30.616 79.376 30.135 L 79.474 30.135 L 79.474 30.713 C 79.474 32.253 78.597 33.12 77.234 33.12 C 76.163 33.12 75.385 32.35 75.19 31.676 L 73.632 32.35 C 74.119 33.409 75.287 34.757 77.332 34.757 C 79.474 34.757 81.222 33.505 81.222 30.52 L 81.222 23.206 L 79.474 23.206 L 79.474 23.88 Z M 77.332 29.557 C 76.066 29.557 74.995 28.498 74.995 27.054 C 74.995 25.609 76.066 24.55 77.332 24.55 C 78.597 24.55 79.571 25.609 79.571 27.054 C 79.571 28.498 78.597 29.557 77.332 29.557 Z M 101.076 18.873 L 96.695 18.873 L 96.695 30.905 L 98.544 30.905 L 98.544 26.38 L 101.076 26.38 C 103.116 26.38 105.063 24.935 105.063 22.628 C 105.063 20.317 103.116 18.873 101.076 18.873 Z M 101.173 24.647 L 98.544 24.647 L 98.544 20.51 L 101.173 20.51 C 102.532 20.51 103.311 21.666 103.311 22.532 C 103.214 23.591 102.435 24.647 101.173 24.647 Z M 112.362 22.917 C 110.998 22.917 109.635 23.495 109.149 24.743 L 110.804 25.417 C 111.193 24.743 111.777 24.55 112.459 24.55 C 113.432 24.55 114.309 25.128 114.406 26.091 L 114.406 26.187 C 114.114 25.995 113.335 25.706 112.556 25.706 C 110.804 25.706 109.055 26.669 109.055 28.402 C 109.055 30.039 110.512 31.098 112.069 31.098 C 113.335 31.098 113.919 30.52 114.406 29.942 L 114.503 29.942 L 114.503 30.905 L 116.256 30.905 L 116.256 26.284 C 116.061 24.165 114.406 22.917 112.362 22.917 Z M 112.167 29.557 C 111.583 29.557 110.706 29.268 110.706 28.498 C 110.706 27.535 111.777 27.246 112.654 27.246 C 113.432 27.246 113.822 27.439 114.309 27.632 C 114.114 28.787 113.14 29.557 112.167 29.557 Z M 122.386 23.206 L 120.341 28.402 L 120.244 28.402 L 118.102 23.206 L 116.159 23.206 L 119.367 30.52 L 117.518 34.564 L 119.367 34.564 L 124.329 23.206 L 122.386 23.206 Z M 106.037 30.905 L 107.887 30.905 L 107.887 18.873 L 106.037 18.873 L 106.037 30.905 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M 47.668 10.378 C 47.668 11.079 47.507 11.694 47.103 12.13 C 46.618 12.656 46.053 12.919 45.326 12.919 C 44.604 12.919 44.039 12.656 43.554 12.13 C 43.069 11.605 42.827 10.992 42.827 10.201 C 42.827 9.412 43.069 8.797 43.554 8.27 C 44.039 7.743 44.604 7.48 45.326 7.48 C 45.65 7.48 45.972 7.568 46.296 7.743 C 46.618 7.919 46.861 8.095 47.021 8.358 L 46.618 8.797 C 46.296 8.358 45.891 8.183 45.326 8.183 C 44.845 8.183 44.36 8.358 44.039 8.797 C 43.634 9.148 43.474 9.675 43.474 10.289 C 43.474 10.904 43.634 11.43 44.039 11.782 C 44.442 12.13 44.845 12.393 45.326 12.393 C 45.891 12.393 46.296 12.216 46.699 11.782 C 46.942 11.518 47.103 11.167 47.103 10.728 L 45.326 10.728 L 45.326 10.026 L 47.668 10.026 L 47.668 10.378 Z M 51.379 8.183 L 49.202 8.183 L 49.202 9.85 L 51.217 9.85 L 51.217 10.465 L 49.202 10.465 L 49.202 12.13 L 51.379 12.13 L 51.379 12.831 L 48.557 12.831 L 48.557 7.568 L 51.379 7.568 L 51.379 8.183 Z M 54.043 12.831 L 53.397 12.831 L 53.397 8.183 L 52.024 8.183 L 52.024 7.568 L 55.416 7.568 L 55.416 8.183 L 54.043 8.183 L 54.043 12.831 Z M 57.754 12.831 L 57.754 7.568 L 58.4 7.568 L 58.4 12.831 L 57.754 12.831 Z M 61.144 12.831 L 60.499 12.831 L 60.499 8.183 L 59.127 8.183 L 59.127 7.568 L 62.436 7.568 L 62.436 8.183 L 61.064 8.183 L 61.064 12.831 L 61.144 12.831 Z M 68.812 12.13 C 68.327 12.656 67.762 12.919 67.036 12.919 C 66.309 12.919 65.744 12.656 65.259 12.13 C 64.775 11.605 64.533 10.992 64.533 10.201 C 64.533 9.412 64.775 8.797 65.259 8.27 C 65.744 7.743 66.309 7.48 67.036 7.48 C 67.762 7.48 68.327 7.743 68.812 8.27 C 69.292 8.797 69.535 9.412 69.535 10.201 C 69.535 10.992 69.292 11.605 68.812 12.13 Z M 65.744 11.694 C 66.067 12.041 66.55 12.305 67.036 12.305 C 67.521 12.305 68.004 12.13 68.327 11.694 C 68.651 11.342 68.889 10.816 68.889 10.201 C 68.889 9.587 68.731 9.06 68.327 8.709 C 68.004 8.358 67.521 8.095 67.036 8.095 C 66.55 8.095 66.067 8.27 65.744 8.709 C 65.42 9.06 65.179 9.587 65.179 10.201 C 65.179 10.816 65.341 11.342 65.744 11.694 Z M 70.423 12.831 L 70.423 7.568 L 71.15 7.568 L 73.492 11.694 L 73.492 7.568 L 74.137 7.568 L 74.137 12.831 L 73.492 12.831 L 70.988 8.534 L 70.988 12.831 L 70.423 12.831 Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(255, 255, 255)",
      strokeMiterlimit: 10,
      strokeWidth: "0.2px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.b02537f8360ae1fae87130b158637867.svg";
export { ForwardRef as ReactComponent };